var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tixstock-tags-skeleton mt-5"},_vm._l((3),function(index){return _c('div',{key:index,staticClass:"tixstock-tags-box-skeleton"},[_c('div',{staticClass:"search-tag-skeleton"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }